




































































import {Component, Emit, Mixins, Prop, PropSync} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import {ResponsibleObjectType, ReturnWayType} from '@/types/claim';
import {ReturnsPredict} from 'supporter';

@Component({
  components: {
    CompSelectBox
  },
  computed: {
    isSellerResponsible(){
      return this.responsibleObjectType === ResponsibleObjectType.SELLER
    },
    isBuyerCollect(){
      return this.returnWayType === ReturnWayType.BUYER_DIRECT_RETURN
    },
    lineThrough(){
      return this.isSellerResponsible ? 'line-through':'none'
    },
    adjustAmountInputDisabled(){
      return this.isSellerResponsible || this.isBuyerCollect || !this.returnDelivery.prepaid
    }
  }
})
export default class ReturnDeliveryAmount extends Mixins(AmountMixin){
  @Prop({required: true})
  private readonly isModifyMode!: boolean
  @Prop({required: true})
  private readonly returnWayType!: ReturnWayType
  @Prop({required: true})
  private readonly responsibleObjectType!: ResponsibleObjectType
  @Prop({required: false})
  private readonly returnsPredict: null | ReturnsPredict = null
  @PropSync('returnDeliveryAdjustAmt')
  private returnDeliveryAdjustAmtSync!: string
  @PropSync('returnDeliveryAmtAdjustReason')
  private returnDeliveryAmtAdjustReasonSync!: string

  private showWhoDoesPay: boolean = false

  // 반품배송비 row
  private returnDelivery = {
    returnDeliveryAmt: 0, // 기본배송비
    returnRemoteDeliveryAmt: 0, // 지역별추가
    returnDeliveryAdjustAmt: 0, // 금액조정(선택)
    returnDeliveryAmtAdjustReason: '', // 조정사유
    prepaid: false,
  }

  // 배송비합계 (b) row
  private totalDelivery = {
    totalDeliveryAmt: 0,
  }

  created(){
    this.setReturnDelivery()
    this.setTotalDelivery()
  }

  private setReturnDelivery() {
    const {returnDeliveryAmt, returnRemoteDeliveryAmt} = this.amounts.returnDelivery
    const {returnDeliveryAdjustAmt, returnDeliveryAmtAdjustReason} = this.claimNoResponseData
    const prepaid = this.claimNoResponseData.claimData.shipping.prepaid

    this.returnDelivery = {
      prepaid,
      returnDeliveryAmt,
      returnRemoteDeliveryAmt,
      returnDeliveryAdjustAmt,
      returnDeliveryAmtAdjustReason,
    }
  }

  private setTotalDelivery() {
    const {prepaidReturnDeliveryAmt, prepaidReturnRemoteDeliveryAmt} = this.amounts.returnDelivery
    const returnDeliveryAdjustAmt = this.returnDelivery.returnDeliveryAdjustAmt
    const isPrepaid = this.claimNoResponseData.claimData.shipping.prepaid

    this.totalDelivery.totalDeliveryAmt = prepaidReturnDeliveryAmt + prepaidReturnRemoteDeliveryAmt - (isPrepaid ? returnDeliveryAdjustAmt : 0);
  }

  public resetAsPredictedAmounts(){
    this.setReturnsPredict()
    this.setTotalDeliveryPredict()
  }

  private setReturnsPredict() {
    const {returnDeliveryAmt, returnRemoteDeliveryAmt, prepaid} = this.returnsPredict.amounts.returnDelivery
    const {returnDeliveryAdjustAmt} = this.returnsPredict.amounts

    this.returnDelivery = {
      ...this.returnDelivery,
      prepaid,
      returnDeliveryAmt,
      returnRemoteDeliveryAmt,
      returnDeliveryAdjustAmt,
    }
  }

  // https://nhnent.dooray.com/project/posts/2711631288263591700
  // 배송비합계 = 반품기본배송비 + 반품지역별추가배송비 - 반품조정금액
  private setTotalDeliveryPredict() {
    const {prepaidReturnDeliveryAmt, prepaidReturnRemoteDeliveryAmt} = this.returnsPredict.amounts.returnDelivery
    const returnDeliveryAdjustAmt = this.returnsPredict.amounts.returnDeliveryAdjustAmt
    const isPrepaid = this.returnsPredict.shipping.prepaid

    this.totalDelivery.totalDeliveryAmt = prepaidReturnDeliveryAmt + prepaidReturnRemoteDeliveryAmt - (isPrepaid ? returnDeliveryAdjustAmt : 0);
  }

  @Emit('deliveryAdjustAmtBlur')
  private onAdjustAmtBlur(){
    this.validation()
    this.toggleShowWhoDoesPay();
  }

  private toggleShowWhoDoesPay(){
    this.showWhoDoesPay = Number(this.returnDeliveryAdjustAmtSync) > 0
  }

  private validation(): void{
    const {returnDeliveryAmt, returnRemoteDeliveryAmt} = this.returnDelivery
    const adjustAmt = Number(this.returnDeliveryAdjustAmtSync.replace(',',''))

    if(returnDeliveryAmt + returnRemoteDeliveryAmt < adjustAmt){
      alert(this.$t('CLAIM_POPUP_ADJUST_AMOUNT_EXCESS_DELIVERY_AMOUNT_VALID_MESSAGE').toString())
      this.returnDeliveryAdjustAmtSync = '0'
      return
    }
  }

}
